import { render } from "./AccountCreateComponent.vue?vue&type=template&id=6c6aa790&scoped=true"
import script from "./AccountCreateComponent.vue?vue&type=script&lang=js"
export * from "./AccountCreateComponent.vue?vue&type=script&lang=js"

import "./AccountCreateComponent.vue?vue&type=style&index=0&id=6c6aa790&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6aa790"]])

export default __exports__